<template>
<div>
  <v-navigation-drawer
    v-if="$mq.md"
    stateless
    value="true"
    app fixed permanent clipped
    mobile-break-point="1024"
    width="295"
    class="bg-light-gray flex flex-column pb0"
  >
    <!-- https://vuetifyjs.com/en/components/lists#example-expansion-lists  See example for Dining -->
    <v-list expand>
      
      <v-list-group v-if='sysAdmin() || sysRo()'
        prepend-icon="security"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-title>System</v-list-item-title>
        </template>

        <v-list-item
          v-for="(item, ix) in adminOnlyItems"
          :href='item.link'
          :key="'admin-only-item-'+ix"
        >
          <v-list-item-title v-text="item.title"></v-list-item-title>
          <v-list-item-action>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-action>
        </v-list-item>

      </v-list-group>
  
      <v-list-item v-else href="/#/dashboard">
        <v-list-item-action>
          <v-icon>dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item>

      <v-list-group
        prepend-icon="device_hub"
        no-action
        value="true"
      >
        <template v-slot:activator>
          <v-list-item-title>Network</v-list-item-title>
        </template>
        <v-list-item
          v-for="(net, i) in networkitems"
          :key="i"
          :href="net.link"
        >
          <v-list-item-title v-text="net.title"></v-list-item-title>
          <v-list-item-action>
            <v-icon v-text="net.icon"></v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list-group>
      
      <v-list-group
        prepend-icon="radio_button_on"
        no-action
        value="true"
      >
        <template v-slot:activator>
          <v-list-item-title>Device</v-list-item-title>
        </template>
        <v-list-item
          v-for="(ed, i) in deviceitems"
          :key="i"
          :href="ed.link"
        >
          <v-list-item-title v-text="ed.title"></v-list-item-title>
          <v-list-item-action>
            <v-icon v-text="ed.icon"></v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list-group>

      <v-list-group
        prepend-icon="account_circle"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-title>User</v-list-item-title>
        </template>

        <v-list-item v-if='sysAdmin() || sysRo()'
          v-for="(ed, i) in systemitems"
          :key="'system-item-key'+i"
          :href="ed.link"
        >
          <v-list-item-title v-text="ed.title"></v-list-item-title>
          <v-list-item-action>
            <v-icon v-text="ed.icon"></v-icon>
          </v-list-item-action>
        </v-list-item>
        
        <v-list-item
          v-for="(ed, i) in useritems"
          :key="i"
          :href="ed.link"
        >
          <v-list-item-title v-text="ed.title"></v-list-item-title>
          <v-list-item-action>
            <v-icon v-text="ed.icon"></v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list-group>

      <v-list-item href="/#/logout">
        <v-list-item-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-item-action>
        <v-list-item-title>Log Out</v-list-item-title>
      </v-list-item>
    </v-list>
    <v-spacer />
    <LogoMultitech style="width: 160px" class="ml2 mb2" />
  </v-navigation-drawer>

  <v-toolbar v-else>
    <v-layout align-center justify-space-around >
      <v-btn to="/dashboard"><v-icon>dashboard</v-icon><span v-if="$mq.md_sm">Dashboard</span></v-btn>
      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on"><v-icon>device_hub</v-icon><span v-if="$mq.md_sm">Network</span></v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(net, i) in networkitems"
            :key="i"
            :href="net.link"
          >
            <v-list-item-title v-text="net.title"></v-list-item-title>
            <v-list-item-action>
              <v-icon v-text="net.icon"></v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on"><v-icon>radio_button_on</v-icon><span v-if="$mq.md_sm">Device</span></v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(net, i) in deviceitems"
            :key="i"
            :href="net.link"
          >
            <v-list-item-title v-text="net.title"></v-list-item-title>
            <v-list-item-action>
              <v-icon v-text="net.icon"></v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on"><v-icon>account_circle</v-icon><span v-if="$mq.md_sm">User</span></v-btn>
        </template>
        <v-list>
          <v-list-item v-if='sysAdmin() || sysRo()'
            :href='systemitem.link'
          >
          <v-list-item-title v-text="systemitem.title"></v-list-item-title>
          <v-list-item-action>
            <v-icon v-text="systemitem.icon"></v-icon>
          </v-list-item-action>
          </v-list-item>
          <v-list-item
            v-for="(net, i) in useritems"
            :key="i"
            :href="net.link"
          >
            <v-list-item-title v-text="net.title"></v-list-item-title>
            <v-list-item-action>
              <v-icon v-text="net.icon"></v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn to="/logout"><v-icon>exit_to_app</v-icon><span v-if="$mq.md_sm">Log Out</span></v-btn>
    </v-layout>
  </v-toolbar>
</div>
</template>

<script>
import LogoMultitech from '@/components/LogoMultitech'
import {sysAdmin, sysRo} from '@/utils/api'
import icons from '@/icons'

export default {
  extends: {
    methods: {
      sysAdmin,
      sysRo,
    },
  },
  data: () => ({
    icons,
    networkitems: [
      {
        title: 'Application Networks',
        link: '/#/application-networks',
        icon: 'device_hub',
      },
      {
        title: 'Gateways',
        link: '/#/gateways',
        icon: 'router',
      },
      {
        title: 'Policies',
        link: '/#/policies',
        icon: 'lock',
      },
      {
        title: 'Network Profiles',
        link: '/#/application-networks/profiles',
        icon: 'assignment',
      },
    ],
    deviceitems: [
      {
        title: 'End-Devices',
        link: '/#/end-devices',
        icon: 'radio_button_on',
      },
      {
        title: 'Device Groups',
        link: '/#/end-devices/groups',
        icon: 'select_all',
      },
      {
        title: 'Operations',
        link: '/#/operations',
        icon: 'settings_remote',
      },
      {
        title: 'Device Profiles',
        link: '/#/end-devices/profiles',
        icon: 'assignment',
      },
    ],
    useritems: [
      {
        title: 'Organization',
        link: '', // See watch and mount operations below
        icon: 'business',
      },
      {
        title: 'Activity',
        link: '', // See watch and mount operations below
        icon: 'toc',
      },
      {
        title: 'License',
        link: '', // See watch and mount operations below
        icon: 'folder'
      },
      {
        title: 'Broadcast',
        link: '', // See watch and mount operations below
        icon: 'email'
      },
      {
        title: 'People',
        link: '/#/people',
        icon: 'supervisor_account',
      },
      {
        title: 'Profile',
        link: '/#/me',
        icon: 'account_circle',
      },
      {
        title: 'Support',
        link: '/#/support',
        icon: 'help_outline',
      },
    ],
    devicehqitems: [
      {
        title: 'DeviceHQ',
        link: '/#/devicehq/login',
        icon: 'account_balance',
      },
      {
        title: 'Account',
        link: '/#/devicehq/account',
        icon: 'account_circle',
      },
      {
        title: 'Users',
        link: '/#/devicehq/users',
        icon: 'supervisor_account',
      },
      {
        title: 'Devices',
        link: '/#/devicehq/devices',
        icon: 'radio_button_on',
      },
      {
        title: 'Dev View',
        link: '/#/devicehq/device',
        icon: 'radio_button_on',
      },
    ],
    systemitems: [
      {
        title: 'Organizations',
        link: '/#/organizations',
        icon: 'group_work',
      },
    ],
    adminOnlyItems: [ 
      {
        title: 'Dashboard',
        link: '/#/dashboard',
        icon: 'dashboard',
      },
      {
        title: 'Service Api Keys',
        link: '/#/service-api-keys',
        icon: icons.serviceApiKeyIcon,
      },
      {
        title: 'Settings',
        link: '/#/systemlimits',
        icon: 'settings',
      },
      {
        title: 'Services',
        link: '/#/vaults',
        icon: 'lock',
        oldTag: "vaultitem",
      },
      {
        title: 'Broadcast',
        link: '/#/systembroadcast',
        icon: 'email',
        oldTag: "systembroadcastitem",
      },
    ],
  }),
  components: {
    LogoMultitech
  },
  computed: {
    currentUserOrganizationPath: function() {
      return '/#/my_organization/' + this.$store.getters.currentOrganization.id
    },
  },
  mounted() {
    this.useritems[0].link = this.currentUserOrganizationPath
    this.useritems[1].link = '/#/organization/' + this.$store.getters.currentOrganization.id
    this.useritems[2].link = '/#/organization/' + this.$store.getters.currentOrganization.id + '/license'
    this.useritems[3].link = '/#/organization/' + this.$store.getters.currentOrganization.id + '/broadcasts'
  },
}
</script>

<style scoped>
.navigation-drawer > .list .list__tile--active {
  color: #0072ce;
  background-color: #ecedef;
  border-right: 1px solid #dee1e3;
  font-weight: bold;
}

.toolbar {
  height: 55px !important;
}

.btn {
  min-width: 10px;
}

.container {
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/SlideSidebarMenu.vue